import Anthropic from '@anthropic-ai/sdk'

export interface ClaudeClientConfig {
  apiKey: string
}

export interface ModelOption {
  id: string
  label: string
}

export const DEFAULT_MODEL = 'claude-sonnet-4-6'

export const AVAILABLE_MODELS: ModelOption[] = [
  { id: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 (raccomandato)' },
  { id: 'claude-opus-4-7', label: 'Claude Opus 4.7 (più capace)' },
  { id: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5 (veloce / economico)' },
]

export function createClient(config: ClaudeClientConfig): Anthropic {
  return new Anthropic({
    apiKey: config.apiKey,
    dangerouslyAllowBrowser: true,
  })
}

export async function pingApi(client: Anthropic, model: string = DEFAULT_MODEL): Promise<string> {
  const response = await client.messages.create({
    model,
    max_tokens: 64,
    messages: [{ role: 'user', content: 'Rispondi solo con la parola "ok".' }],
  })
  const textBlock = response.content.find(b => b.type === 'text')
  return textBlock && textBlock.type === 'text' ? textBlock.text : ''
}
